export default __webpack_public_path__ + "static/media/ladybrand-icon.e3c99967.svg";